import React from 'react';
import { PageContainer } from 'shared/components/PageContainer';
import { App_PortalFragment } from '../generated.graphql';
import { getContinueShoppingUrl } from 'rental/steps/cart/resolvers';


interface Props {
  portal: App_PortalFragment
}


export const EmptyApplicationFlush = (props: Props) => {
  const inStore = props.portal.myApplication?.inStore;
  const addProductUrl = getContinueShoppingUrl(props);
  return (
    <div className="py-5 text-center">
      <div className="pb-3">
        There are no items in your cart. 
      </div>
      {!inStore && addProductUrl &&
        <div className="">
          <a href={addProductUrl} className="btn btn-primary">Add Item</a>
        </div>
      }
      {inStore &&
        <div className="">
          Contact your store to start a new application.
        </div>
      }
    </div>
  )
};


export const EmptyApplication = (props: Props) => (
  <PageContainer>
    <EmptyApplicationFlush {...props}/>
  </PageContainer>
);

